export const ADD_POPULAR_ODD_TO_COLLECTION = 'ADD_POPULAR_ODD_TO_COLLECTION'
export const ADD_ALL_ODDS_TO_COLLECTION = 'ADD_ALL_ODDS_TO_COLLECTION'
export const SELECT_SPORT_MENU = 'SELECT_SPORT_MENU'
export const ADD_LIG_ITEM_TO_COLLECTION = 'ADD_LIG_ITEM_TO_COLLECTION'
export const ADD_TEASER_ITEM_TO_COLLECTION = 'ADD_TEASER_ITEM_TO_COLLECTION'
export const SET_TIP_COLLECTION_MODAL_STATUS = 'SET_TIP_COLLECTION_MODAL_STATUS'
export const REMOVE_ITEM_FROM_TIP_COLLECTION = 'REMOVE_ITEM_FROM_TIP_COLLECTION'
export const REMOVE_ALL_ITEMS = 'REMOVE_ALL_ITEMS'